import React from "react";
import LogoWhite from "./Assets/CAP_2025_Payoff_RGB_White.svg";
import IconFacebook from "gruppocap-ui-fe/dist/resources/img/New Icon/Facebook.svg";
import IconInstagram from "gruppocap-ui-fe/dist/resources/img/New Icon/Instagram.svg";
import IconX from "gruppocap-ui-fe/dist/resources/img/New Icon/X.svg";
import IconYouTube from "gruppocap-ui-fe/dist/resources/img/New Icon/Youtube.svg";
import IconLinkedin from "gruppocap-ui-fe/dist/resources/img/New Icon/Linkedin.svg";
import IconBureauVeritas from "gruppocap-ui-fe/dist/resources/img/New Icon/Icona footer 1.svg";
import IconVincitoreEdizione from "gruppocap-ui-fe/dist/resources/img/New Icon/Icona footer 2.svg";
import ChatButton from "../ChatButton/ChatButton";
import { Link } from "react-router-dom";
import "./AppFooter.scss";
import { ServiceLink, getCorrectLink } from "../../../helpers/helpers";
import getMenuConfig from "../../../helpers/menuConfig";
import ChatPage from "../../pages/ChatPage/ChatPage";
import { useTranslation } from "react-i18next";

const AppFooter = () => {
  const { t } = useTranslation();
  const { footerLinks, socialLinks, copyright, footerAdditionalIcons } =
    getMenuConfig();
  const firstColumn = Array.isArray(footerLinks[0]) ? footerLinks[0] : [];
  const secondColumn = Array.isArray(footerLinks[1]) ? footerLinks[1] : [];
  const thirdColumn = Array.isArray(footerLinks[2]) ? footerLinks[2] : [];
  const { facebook, instagram, twitter, youtube, linkedin } = socialLinks;
  let social = "";
  const regex = /(?:http(?:s)?:\/\/)?(?:w{3}\.)?([^\.]+)/i;
  const startEventDataLayer = (s) => {
    if (s.url) {
      social = s.url.match(regex);
      if (social.length > 1 && social[1]) {
        window.dataLayer.push({ event: "link_social", tipo: social[1] });
      }
    }
  };

  return (
    <footer className="footer bg-grey-0" data-testid="AppFooter">
      <div className="container paragraph-main-fs8 font-color-2">
        <div className="footer__logo">
          <div className="footer-navbar-brand">
            <Link
              to={"/"}
              className={"d-block footer-navbar-brand-image"}
              aria-label={t("footer.logo.aria.label")}
            >
              <img src={LogoWhite} alt="logo CAP" />
            </Link>
            <div className="footer__socials d-sm-block d-none">
              <div className="row">
                {socialLinks?.length ? (
                  socialLinks?.map((s, i) => (
                    <a
                      onClick={() => startEventDataLayer(s)}
                      key={i}
                      href={getCorrectLink(s.url)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer__socials-image-icon"
                    >
                      <span className="sr-only">{s.iconAlt}</span>
                      <img alt={s.iconAlt} src={getCorrectLink(s.iconPath)} />
                    </a>
                  ))
                ) : (
                  <>
                    <a
                      href={getCorrectLink(facebook)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer__socials-image-icon"
                    >
                      <span className="sr-only">Facebook</span>
                      <img src={IconFacebook} alt="Facebook" />
                    </a>
                    <a
                      href={getCorrectLink(instagram)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer__socials-image-icon"
                    >
                      <span className="sr-only">Instagram</span>
                      <img src={IconInstagram} alt="Instagram" />
                    </a>
                    <a
                      href={getCorrectLink(twitter)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer__socials-image-icon"
                    >
                      <span className="sr-only">Twitter</span>
                      <img src={IconX} alt="Twitter" />
                    </a>
                    <a
                      href={getCorrectLink(youtube)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer__socials-image-icon"
                    >
                      <span className="sr-only">Youtube</span>
                      <img src={IconYouTube} alt="Youtube" />
                    </a>
                    <a
                      href={getCorrectLink(linkedin)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer__socials-image-icon"
                    >
                      <span className="sr-only">LinkedIn</span>
                      <img src={IconLinkedin} alt="LinkedIn" />
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="footer__content content">
          <div className="footer__menu">
            <ul className="d-flex flex-column">
              {firstColumn?.map((item, index) => {
                return (
                  <li key={item.label + "_" + index}>
                    {item.label !== "" && <ServiceLink linkObject={item} />}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="footer__menu">
            <ul className="d-flex flex-column">
              {secondColumn?.map((item, index) => {
                return (
                  <li key={item.label + "_" + index}>
                    {item.label !== "" && <ServiceLink linkObject={item} />}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="footer__menu">
            <ul className="d-flex flex-column">
              {thirdColumn?.map((item, index) => {
                return (
                  <li key={item.label + "_" + index}>
                    {item.label !== "" && <ServiceLink linkObject={item} />}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="footer__socials d-sm-none">
          <div className="row">
            {socialLinks?.length ? (
              socialLinks?.map((s, i) => (
                <a
                  onClick={() => startEventDataLayer(s)}
                  key={i}
                  href={getCorrectLink(s.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__socials-image-icon"
                >
                  <span className="sr-only">{s.iconAlt}</span>
                  <img alt={s.iconAlt} src={getCorrectLink(s.iconPath)} />
                </a>
              ))
            ) : (
              <>
                <a
                  href={getCorrectLink(facebook)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__socials-image-icon"
                >
                  <span className="sr-only">Facebook</span>
                  <img src={IconFacebook} alt="Facebook" />
                </a>
                <a
                  href={getCorrectLink(instagram)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__socials-image-icon"
                >
                  <span className="sr-only">Instagram</span>
                  <img src={IconInstagram} alt="Instagram" />
                </a>
                <a
                  href={getCorrectLink(twitter)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__socials-image-icon"
                >
                  <span className="sr-only">Twitter</span>
                  <img src={IconX} alt="Twitter" />
                </a>
                <a
                  href={getCorrectLink(youtube)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__socials-image-icon"
                >
                  <span className="sr-only">Youtube</span>
                  <img src={IconYouTube} alt="Youtube" />
                </a>
                <a
                  href={getCorrectLink(linkedin)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__socials-image-icon"
                >
                  <span className="sr-only">LinkedIn</span>
                  <img src={IconLinkedin} alt="LinkedIn" />
                </a>
              </>
            )}
          </div>
        </div>
        <div className="footer__copyright paragraph-small-fs9">
          <p>{copyright}</p>
          <div className="footer__copyright-icons">
            {footerAdditionalIcons ? (
              footerAdditionalIcons?.map((item, index) => {
                return (
                  <img
                    key={index}
                    src={getCorrectLink(item.path)}
                    alt={item.altIcon}
                  />
                );
              })
            ) : (
              <>
                <img
                  src={IconBureauVeritas}
                  alt="Icon BUREAU VERITAS Certification ISO 27001"
                />
                <img
                  src={IconVincitoreEdizione}
                  alt="Icon TOP UTILITY Vincitore XIII Edizione"
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="floating-chat d-none">
        <ChatButton />
      </div>
      <ChatPage />
    </footer>
  );
};

export default AppFooter;
